var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('main', {
    staticClass: "main-body"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('img', {
    staticClass: "news-banner-img",
    attrs: {
      "src": require('@/assets/imgs/news/top_banner.jpg'),
      "alt": ""
    }
  }), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('RouterView')], 1)], 1)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };